export enum SearchQueryKey {
    Sort = 'sort',
    Duration = 'duration',
    BookingFeature = 'bookingFeature',
    Rating = 'rating',
    PriceFrom = 'priceFrom',
    PriceTo = 'priceTo',
    PageNumber = 'page',
    Supplier = 'supplier',
    Category = 'category',
    SelectedActivity = 'selectedActivity',
    TravelDate = 'travelDate',
    EndDate = 'endDate',
    CityId = 'cityId',
    Keyword = 'keyword',
    Currency = 'currency',
    Subcategory = 'subcategory',
    EnrichedOfferId = 'enrichedOfferId',
    OfferOptionId = 'offerOptionId',
    Pax = 'pax',
}
